<template>

    <div id="sites-tab">
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <customModalSidebar v-on:removeSource="fetchSites" v-on:changeSource="refreshSitePhoto"
                            :settings="customSidebarSettings"></customModalSidebar>

        <div class="empty-contain" v-if="isShowAddSiteBtnBool && !sitesList.length && !sitesSpinner">
            <div class="top" :class="{'show-btn': isShowAddSiteBtnBool}">
                <img src="@/assets/icons/ic_puzzle.svg" alt="">
                <h3>{{translate('EmptySiteTitle')}}</h3>
                <p>{{translate('EmptySiteDescription')}}</p>
                <b-button @click="onAddSiteClick" class="add-new-site re-btn">
                    <img src="@/assets/icons/ic_+.svg" alt="">
                    <span>{{translate('addNewSite')}}</span>
                </b-button>
            </div>
        </div>
        <div class="contain" v-else-if="!sitesSpinner">
            <div class="top" :class="{'show-btn': isShowAddSiteBtnBool}">
                <div class="left-column">
                    <p class="description">{{translate('SitesDescription')}}</p>
                </div>
            </div>
            <div class="bottom">
                <ul class="list" v-if="!sitesSpinner">
                    <li v-for="(site, index) in sitesList" :key="index"
                        :class="selectedItem == index ? 'active-element' : ''">
                        <div class="top">
                            <h6>{{site.name}}</h6>
                            <div class="manage">
                                <b-dropdown no-caret>
                                    <b-dropdown-item @click.stop="onSiteMenuEditClick(site, index)"
                                                     v-if="hasEditPermission">
                                        <img src="@/assets/icons/ic_edit.svg" alt="icon edit">
                                        <span>{{translate('siteDetail')}}</span>
                                    </b-dropdown-item>
                                    <b-dropdown-item @click.stop="onSiteMenuEditPhotoClick(site, index)"
                                                     v-if="hasEditPermission">
                                        <img src="@/assets/icons/ic_photo.svg" alt="icon edit">
                                        <span>{{translate('EditPhoto')}}</span>
                                    </b-dropdown-item>
                                    <b-dropdown-item @click.stop="onSiteMenuEditManagersClick(site, index)"
                                                     v-if="hasEditPermission">
                                        <img src="@/assets/icons/ic_friends.svg" alt="icon managers">
                                        <span v-if="site.managers.length">{{translate('editManagers')}}</span>
                                        <span v-else>{{translate('assignManagers')}}</span>
                                    </b-dropdown-item>
                                    <b-dropdown-item @click.stop="onSiteMenuAnalyticsClick(site)">
                                        <img src="@/assets/icons/ic_smile.svg" alt="icon analytic">
                                        <span>{{translate('viewAnalytic')}}</span>
                                    </b-dropdown-item>
                                    <b-dropdown-item @click.stop="onSiteSecondLevelDetailsClick(site, index)" v-if="checkIfOwnerHaveOriginalCredential()">
                                        <img src="@/assets/icons/ic_cogs.svg" alt="icon analytic">
                                        <span>{{ translate('sldSecondLevelDetails') }} Ⓐ</span>
                                    </b-dropdown-item>
									<b-dropdown-item @click.stop="onSiteServiceLogClick(site, index)" v-if="checkIfOwnerHaveOriginalCredential()">
										<img src="@/assets/icons/ic_cogs.svg" alt="icon analytic">
										<span>{{ translate('serviceLog') }} Ⓐ</span>
									</b-dropdown-item>
                                    <b-dropdown-item @click.stop="onSiteMenuDeleteClick(site, index)"
                                                     v-if="hasEditPermission">
                                        <img src="@/assets/icons/ic_trash.svg" alt="icon trash">
                                        <span class="red-action">{{translate('deleteSite')}}</span>
                                    </b-dropdown-item>
                                </b-dropdown>
                            </div>
                        </div>
                        <div class="content">
                            <div class="img">
                                <img :src="site.preview">
                            </div>
                            <div class="body">
                                <ul class="contact-info">
                                    <li>
                                        <span>{{translate('Alias')}}:</span>
                                        <span>{{site.short_tag}}</span>
                                    </li>
                                    <li v-if="site.address">
                                        <span>{{translate('bi_Address')}}:</span>
                                        <span>{{site.address}}</span>
                                    </li>
                                    <li v-if="site.phone">
                                        <span>{{translate('bi_Phone')}}:</span>
                                        <span>{{site.phone}}</span>
                                    </li>
                                    <li v-if="site.email">
                                        <span>{{translate('Email')}}:</span>
                                        <span>
                                        <a :href="'mailto:' + site.email">{{site.email}}</a>
                                    </span>
                                    </li>
                                    <li v-if="site.website">
                                        <span>{{translate('Website')}}:</span>
                                        <span>
                                        <a :href="site.website" target="_blank">{{site.website}}</a>
                                    </span>
                                    </li>
                                    <li class="managers">
                                        <span>{{translate('siteManagers')}}:</span>
                                        <span v-if="site.managers.length">
                                        <a :href="'mailto:' + managers.email" v-for="(managers, index) in site.managers" :key="index">{{managers.email}}</a>
                                    </span>
                                        <div v-else
                                             class="not-assigned-managers">
                                            <span>{{translate('SiteManagersNotAssigned')}}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </li>
                    <li class="addNewSite__wrapper" v-if="isShowAddSiteBtnBool">
                        <b-button @click="onAddSiteClick" class="add-new-site" variant="dark">
                            <span>{{translate('addNewSite')}}</span>
                        </b-button>
                    </li>
                </ul>
                <div v-else class="block-spinner">
                    <b-spinner style="width: 3rem; height: 3rem;" type="grow" label="Spinning"></b-spinner>
                </div>
            </div>
        </div>
        <div v-else class="block-spinner">
            <b-spinner style="width: 3rem; height: 3rem;" type="grow" label="Spinning"></b-spinner>
        </div>
    </div>

</template>

<script>

import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';

import errorMixin from '@/mixins/errorMixin';
import customModalDialog from '@/components/widgets/customModalDialog';
import customModalSidebar from '@/components/widgets/customModalSidebar';
import logAnalyticsEvent, {logError} from '@/helpers/analytics';

export default {
        mixins: [errorMixin, mixin],
        data() {
            return {
                customModalSettings: {},
                customSidebarSettings: {},
                sitesSpinner: true,
                selectedItem: null,
                sitesList: [],
                isShowAddSiteBtnBool: false
            }
        },
        components: {
            customModalDialog,
            customModalSidebar,
        },

        async mounted() {
            await this.fetchSites()
        },

        computed: {

            ...mapState({
                userInfo: state => state.auth.userInfo,
                isMultipleSites: state => state.auth.isMultipleSites
            }),

            ...mapGetters({
                analyticTabIndex: 'owner/analyticTabIndex',
                getActiveTab: 'owner/getActiveTab',
                isUserOwner: 'auth/isUserOwner',
                isUserOrgManager: 'auth/isUserOrgManager',
                isUserSiteManager: 'auth/isUserSiteManager',
                hasEditPermission: 'auth/hasEditPermission'
            }),

        },

        watch: {
            getActiveTab(value) {
                if (value === this.analyticTabIndex) {
                    console.log(value)
                }
            },
            isMultipleSites() {
                this.isShowAddSiteBtn()
            }
        },

        methods: {

            ...mapMutations({
                setAnalyticFilter: 'owner/setAnalyticFilter',
                setActiveTab: 'owner/setActiveTab',
            }),

            ...mapActions({
                getSiteslist: 'owner/getSiteslist',
                editSiteAction: 'owner/editSite',
                deleteSiteAction: 'owner/deleteSite',
                addSite: 'owner/addSite',
            }),

            refreshSitePhoto(data) {
                this.sitesList[this.selectedItem].preview = data
            },

            isShowAddSiteBtn() {
                if ((this.sitesList.length == 0 && (this.isUserOwner || this.isUserOrgManager)) || this.isMultipleSites) {
                    this.isShowAddSiteBtnBool = true
                } else {
                    this.isShowAddSiteBtnBool = false
                }
            },

            cleanSelectedItem() {
                this.selectedItem = null;
            },

            async fetchSites() {
                this.sitesSpinner = true;
                this.cleanSelectedItem()
                this.customSidebarSettings = {}
                try {
                    const response = await this.getSiteslist()
                    if (response.success) {
                        this.sitesList = response.sites
                        this.sitesSpinner = false;
                        setTimeout(() => {
                            this.isShowAddSiteBtn()
                        }, 0)
                    }
                } catch (e) {
                    this.showErrorModal()
                }
            },

            // ADD SITE
            onAddSiteClick() {
                logAnalyticsEvent(`sites_add_new_click`)
                this.customModalSettings = {
                    addBusinessPopup: true,
                    hideOkButton: true,
                    selectBusinessFlowSettings: {
                        businessFlow: true,
                        siteFlow: true,
                        addressFlow: true,
                        siteSelectorFlow: false,
                        onOkHandler: this.onAddSiteSelectionCompleted,
                    }
                }
                this.cleanSelectedItem()
            },

            //EDIT PHOTO
            editPhoto(item, index) {
                this.selectedItem = index;
                this.customSidebarSettings = {
                    title: this.translate('SitePhoto'),
                    description: this.translate('ImagesSupportedParams'),
                    cancel: true,
                    onCancelAction: this.cleanSelectedItem,
                    photo: item,
                    site_uid: item.uid
                }
            },

            onSiteMenuEditClick(site, index) {
                logAnalyticsEvent(`sites_site_menu_edit_click`)
                this.editSiteSidebar(site, index)
            },

            onSiteMenuEditPhotoClick(site, index) {
                logAnalyticsEvent(`sites_site_menu_edit_photo_click`)
                this.editPhoto(site, index)
            },

            onSiteMenuEditManagersClick(site, index) {
                logAnalyticsEvent(`sites_site_menu_edit_managers_click`)
                this.editManagersSidebar(site, index)
            },

            onSiteMenuAnalyticsClick(site, index) {
                logAnalyticsEvent(`sites_site_menu_analytics_click`)
                this.viewAnalytic(site)
            },

            onSiteMenuDeleteClick(site, index) {
                logAnalyticsEvent(`sites_site_menu_delete_click`)
                this.deleteSiteConfirm(site, index)
            },
            onSiteSecondLevelDetailsClick(site, index) {
                logAnalyticsEvent(`sites_site_sec_level_config_click`)
                this.goToDashboardSecondLevelDetails(site)
            },
			onSiteServiceLogClick(site, index) {
				logAnalyticsEvent(`sites_site_service_log_config_click`)
				this.goToDashboardServiceLog(site)
			},

            // EDIT SITE
            editSiteSidebar(item, index) {
                this.selectedItem = index;
                this.customSidebarSettings = {
                    title: this.translate('siteDetail'),
                    cancel: true,
                    uid: item.uid,
                    onCancelAction: this.cleanSelectedItem,
                    input: [
                        {
                            label: this.translate('siteName'),
                            value: item.name,
                            count: 100,
                            request_name: 'site_name',
                            img: 'ic_case.svg',
                        },
                        {
                            label: this.translate('Alias'),
                            value: item.short_tag,
                            count: 100,
                            request_name: 'short_tag',
                            img: 'ic_alias.svg',
                        },
                        {
                            label: this.translate('siteAddressSidebar'),
                            value: item.address,
                            count: 100,
                            request_name: 'site_address',
                            img: 'ic_pin.svg',
                        },
                        {
                            label: this.translate('bi_Phone'),
                            value: item.phone,
                            count: 50,
                            request_name: 'phone',
                            type: 'tel',
                            img: 'ic_phone.svg',
                        },
                        {
                            label: this.translate('Email'),
                            value: item.email,
                            count: 50,
                            request_name: 'email',
                            img: 'ic_mail.svg',
                        },
                        {
                            label: this.translate('Website'),
                            value: item.website,
                            count: 50,
                            request_name: 'website',
                            img: 'ic_globe.svg',
                        }
                    ],
                    buttons: [
                        {
                            text: this.translate('Save'),
                            action: this.editSite,
                            classList: 'invert_btn',
                            cleanData: false,
                            spinner: false,
                        }
                    ]
                }

            },

            async editSite(item) {
                const body = {
                    name: item.input[0].value,
                    address: item.input[2].value,
                    short_tag: item.input[1].value,
                    email: item.input[4].value,
                    phone: item.input[3].value,
                    website: item.input[5].value,
                }
                try {
                    const response = await this.editSiteAction({
                        body,
                        uid_site: item.uid
                    })
                    if (response.success) {
                        logAnalyticsEvent(`sites_edit_site_success`)
                        this.customSidebarSettings = {}
                        await this.fetchSites()
                    }
                } catch (e) {
                    logError('sites_edit_site_error', e.data.error.message || '')
                    this.showErrorModal(e.data.error.message)
                }
            },

            // EDIT MANAGERS
            editManagersSidebar(item, index) {
                this.selectedItem = index;
                this.customSidebarSettings = {
                    title: this.translate('companyManagers'),
                    description: this.translate('companyManagersDescription'),
                    onCancelAction: this.fetchSites,
                    managers: {
                        guid: this.userInfo.organization ? this.userInfo.organization.guid :
                            this.userInfo.organizations.length ? this.userInfo.organizations[0].guid : this.userInfo.sites[0].organization,
                        placeID: item.uid,
                        cancel: true
                    }
                }
            },

            // VIEW ANALYTIC
            viewAnalytic(item) {
                this.setAnalyticFilter({
                    analyticTimeFilter: {
                        name: 'own_allTime',
                        attr: 'all'
                    },
                    analyticSiteFilter: {
                        tag: item.short_tag,
                        uid: item.uid
                    }
                });

                // go to analytic tab (index:2)
                this.setActiveTab(this.analyticTabIndex)
            },

            // DELETE SITE
            deleteSiteConfirm(item, index) {
                this.selectedItem = index;
                this.customModalSettings = {
                    message: this.translate('deleteSiteConfirm', [item.name]),
                    onOkHandler: this.deleteSite.bind(null, item.uid),
                    showCancelButton: true,
                    onCancelHandler: this.cleanSelectedItem,
                    okButtonText: this.translate('yes'),
                    cancelButtonText: this.translate('no'),
                }
            },
            goToDashboardSecondLevelDetails(site) {
                this.$router.push({name: 'dashboardSecondLevelDetailsPlaces', params: {uid: site.uid, orgUid: site.organization}})
            },
			goToDashboardServiceLog(site) {
				this.$router.push({name: 'dashboardServiceLogPlaces', params: {uid: site.uid, orgUid: site.organization}})
			},


            async onAddSiteSelectionCompleted(siteInfo) {
                try {
                    if (siteInfo.place_tz == null) {
                        try {
                            siteInfo.place_tz = Intl.DateTimeFormat().resolvedOptions().timeZone
                        } catch (e) {
                        }
                    }
                    const response = await this.addSite(siteInfo)
                    logAnalyticsEvent(`sites_add_new_success`)
                    await this.fetchSites()
                    this.sitesList.forEach((item, index) => {
                        if (item.uid == response.uid) {
                            return this.editSiteSidebar(item, index)
                        }
                    })
                } catch (e) {
                    logError('sites_add_new_error', e.data.error.message || '')
                    this.showErrorModal(e.data.error.message)
                } finally {
                    this.customModalSettings = {}
                }
            },

            async deleteSite(uid_site) {
                try {
                    await this.deleteSiteAction(uid_site)
                    logAnalyticsEvent(`sites_delete_site_success`)
                    await this.fetchSites()
                } catch (e) {
                    if(e.data.error.code == 1159) {
                        this.showErrorModal("Unsafe action. Please contact support", {title: 'Delete business site'})
                    } else {
                        logError('sites_delete_site_error', e.data.error.message || '')
                        this.showErrorModal(e.data.error.message)
                    }
                }
            },
            checkIfOwnerHaveOriginalCredential() {
              return localStorage.getItem('originalCredentials') !== null
            }

        }
    }

</script>

<style scoped>

    .empty-contain {
        text-align: center;
        margin-top: 56px;
    }

    .empty-contain .top > img {
        width: 64px;
    }

    .empty-contain h3 {
        max-width: 286px;
        color: #9E9E9E;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
        margin-bottom: 21px;
        margin-top: 7px;
    }

    .empty-contain p {
        max-width: 446px;
        color: #2F2F2F;
        font-size: 14px;
        line-height: 22px;
        text-align: center;
        letter-spacing: 0;
    }

    .empty-contain .top {
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    #sites-tab .contain {
        border-radius: 4px;
        margin-top: 23px;
    }

    #sites-tab .contain h4 {
        font-size: 20px;
        font-weight: bold;
        /*line-height: 56px;*/
    }

    #sites-tab .contain p.description {
        color: #2F2F2F;
        font-size: 14px;
        line-height: 22px;
        /*font-weight: 500;*/
        margin-bottom: 25px;
    }

    #sites-tab .contain h5 {
        color: #2F2F2F;
        font-size: 16px;
        font-weight: bold;
        line-height: 26px;
    }

    #sites-tab .contain .top.show-btn {
        display: grid;
        grid-template-columns: auto auto;
        grid-gap: 15px;
    }

    #sites-tab .contain .top.show-btn .left-column {
        padding-right: 10%;
    }

    #sites-tab .contain .top.show-btn .right-column {
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;
    }

    #sites-tab .contain .top:not(.show-btn) .right-column {
        display: none;
    }

    #sites-tab .contain .top.show-btn .right-column .add-new-site {
        background-color: #2F2F2F;
        padding: 7px 15px;
    }

    #sites-tab .contain .top .right-column .add-new-site img {
        margin-right: 10px;
    }

    #sites-tab .contain .top .right-column .add-new-site span {
        font-weight: 500;
        line-height: 32px;
        font-size: 14px;
    }

    /*  */
    #sites-tab .bottom {
        position: relative;
        min-height: 250px;
    }

    #sites-tab .bottom ul.list {
        display: grid;
        grid-template-columns: repeat(2, calc(50% - 12px));
        grid-gap: 24px;
        padding: 0;
    }

    #sites-tab .bottom ul.list > li {
        position: relative;
        background-color: #FFFFFF;
        -webkit-box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.11);
        box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.11);
        padding: 23px 24px;
        border-radius: 4px;
        margin: 0;
        /*padding: 14px 16px;*/
        list-style: none;
    }

    #sites-tab .bottom .addNewSite__wrapper {
        border: 1px dashed #6D6D6D;
        background-color: #F3F3F3 !important;
        display: flex;
        justify-content: center;
        align-items: center;
    }


    #sites-tab .bottom ul.list > li .top {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
    }

    #sites-tab .bottom ul.list > li h6 {
        color: #2F2F2F;
        margin-bottom: 19px;
        font-family: 'Nunito';
        font-weight: 700;
    }

    #sites-tab .bottom ul.list > li .content {
        display: flex;
        justify-content: space-between;
    }

    #sites-tab .bottom ul.list > li.active-element {
        background-color: #F7F7F7;
    }

    #sites-tab .bottom ul.list > li img {
        max-width: unset;
    }

    #sites-tab .bottom ul.list > li * {
        word-break: break-all;
    }

    #sites-tab .bottom ul.list > li .img {
        width: 112px;
        height: 112px;
        min-width: 112px;
        margin-top: 2px;
        margin-right: 16px;
        border-radius: 4px;
        overflow: hidden;
        background: #F3F3F3;
        display: block;
        position: relative;
    }

    #sites-tab .bottom ul.list > li .img img {
        margin: 0 auto;
        min-height: 100%;
        min-width: 100%;
        width: auto;
        max-height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    #sites-tab .bottom ul.list > li .img img.default {
        min-height: 64px;
        min-width: 64px;
    }

    #sites-tab .bottom ul.list > li .body {
        width: 100%;
    }

    #sites-tab .bottom ul.list > li a {
        margin-right: 10px;
        word-break: break-word;
    }

    #sites-tab .bottom ul.list > li .body {
        height: 100%;
        padding-right: 15px;
    }

    #sites-tab .bottom ul.list > li .body h6 {
        color: #2F2F2F;
        font-size: 18px;
        font-weight: bold;
        line-height: 24px;
        margin-top: 12px;
    }

    .bottom ul.list > li .body .contact-info {
        display: table;
    }

    .bottom ul.list > li .body .contact-info li {
        display: table-row;
    }

    .bottom ul.list > li .body .contact-info li span:first-child {
        font-weight: 500;
        color: #2F2F2F;
        white-space: nowrap;
        padding-right: 7px;
    }

    .bottom ul.list > li .body .contact-info li span {
        display: table-cell !important;
        padding: 3px;
    }

    .bottom ul.list > li .body .contact-info li {
        margin: 0 0 6px;
    }

    #sites-tab .bottom ul.list > li .body span {
        display: inline-block;
        margin-right: 10px;
    }

    #sites-tab .bottom ul.list > li .body span,
    #sites-tab .bottom ul.list > li .body a {
        color: #2F2F2F;
        font-size: 14px;
        line-height: 22px;
    }

    #sites-tab .bottom ul.list > li .body a {
        /*color: #1976D2;*/
    }

    #sites-tab .bottom ul.list > li .body .managers {
        margin-top: 7px;
    }

    #sites-tab .bottom ul.list > li .body .managers .not-assigned-managers > span {
        background: #F84900;
        border-radius: 12px;
        color: #fff;
        padding: 4px 9px;
        font-size: 12px;
        line-height: 15px;
        font-weight: 400;
    }


    @media screen and (max-width: 1000px) {

        #sites-tab .contain .top.show-btn {
            display: flex;
            flex-direction: column-reverse;
        }

        #sites-tab .contain .top,
        #sites-tab .bottom ul.list {
            display: grid;
            grid-template-columns: 1fr;
        }

        #sites-tab .bottom ul.list > li {
            position: relative;
        }

        #sites-tab .bottom ul.list > li .content {
            flex-direction: column;
        }

        #sites-tab .bottom ul.list > li .manage {
            position: absolute;
            right: 0;
            top: 10px;

        }
    }

</style>

<style>

    #owner-panel .active-element {
        box-shadow: inset 0 0 0 0.3vw #FFBF00;
        transition: -webkit-box-shadow .3s ease;
        transition: box-shadow .3s ease;
    }

    .manage .dropdown button.btn {
        background: none !important;
        border: 0;
        display: flex;
        align-items: center;
        color: #2F2F2F;
        font-size: 14px;
        padding: 0;
        padding-right: 7px;
        font-weight: 600;
        width: 130px;
        justify-content: flex-end;
    }

    .manage .dropdown button.btn:before {
        content: '';
        background-image: url("~@/assets/icons/ic_kebab.svg");
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        display: block;
        position: relative;
        left: 0;
        top: 0;
        bottom: 0;
        width: 25px!important;
        height: 25px!important;
        margin-right: 4px;
    }

    .manage .dropdown button.btn:focus {
        box-shadow: none !important;
        color: #6c757d;
        background: none;
    }

    .manage .dropdown-menu li {
        margin: 0;
    }

    .manage .dropdown-menu li > a {
        padding: 12px 15px;
        display: flex;
        align-items: center;
        text-decoration: none;
    }

    .manage .dropdown-menu li > a span {
        margin-left: 7px;
        font-weight: 700;
        font-size: 14px;
    }

    .manage .dropdown-menu li a .red-action {
        color: #EF4300;
    }

    .manage .dropdown-menu li:not(:last-child) a:active img {
        filter: invert(1);
    }


    #sites-tab .manage .dropdown button.btn {
        width: 32px;
        height: 32px;
        padding: 0;
    }

    #sites-tab .manage .dropdown button.btn:before {
        background-image: url("~@/assets/icons/ic_kebab-white.svg");
        /*background-color: #2F2F2F;*/
        background-size: 85%;
        border-radius: 50%;
        width: 32px;
        height: 32px;
        margin: 0;
        filter: brightness(0);
    }

    @media screen and (max-width: 1000px) {
        #sites-tab .bottom ul.list > li .manage .dropdown button.btn {
            font-size: 0 !important;
        }

        #sites-tab .bottom ul.list > li .manage .dropdown button.btn:before {
            width: 25px;
            height: 25px;
        }

        #sites-tab .bottom ul.list > li .manage .dropdown-menu {
            top: -30px !important;
            left: -30px !important;
        }
    }
</style>

